import { DRAWER_WIDTH, RESPONSIVE_PADDING, SCREEN_WIDTH } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

export const getDrawerStyles = ({ customStyles, isContentLoading }) => ({
  zIndex: '999',

  ...getConditionalObject(isContentLoading, {
    '& .pending-changes-count-wrapper': {
      display: 'none',
    },
  }),

  ...customStyles,
});

export const wrapperStyles = {
  width: DRAWER_WIDTH,
  padding: RESPONSIVE_PADDING.DESKTOP,
  backgroundColor: ({ palette }) => palette.background.disabled,

  [`@media(max-width: ${SCREEN_WIDTH.M - 1}px)`]: {
    width: '100%',
    padding: RESPONSIVE_PADDING.MOBILE,
  },

  [`@media(min-width: ${SCREEN_WIDTH.M}px) and (max-width: ${SCREEN_WIDTH.L - 1}px)`]: {
    width: 'calc(100% - 100px)',
    padding: RESPONSIVE_PADDING.TABLET,
  },
};

export const contentStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
};
